<img *ngIf="!isImgLoaded" src="assets/images/loading.svg" class="object-fit-cover mb-3 logo" alt="" />
<img
  src="{{ image }}"
  (load)="isImgLoaded = true"
  [ngClass]="{ 'display-none': !isImgLoaded }"
  class="object-fit-cover mb-3 logo"
  alt="" />
